import i18n from "../language/i18n";
async function validateMobilePhone(rule, value) {
  if (value === "") {
    return Promise.reject(i18n.global.t(`tips.tip13`));
  } else {
    if (value !== "") {
      var reg1 = /^1([3456789])\d{9}$/;
      if (!reg1.test(value)) {
        return Promise.reject(i18n.global.t(`tips.tip20`));
      }
    }
    return Promise.resolve();
  }
}

async function validateMobileEmail(rule, value) {
  if (value === "") {
    return Promise.reject(i18n.global.t(`tips.tip17`));
  } else {
    if (value !== "") {
      var reg2 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg2.test(value)) {
        return Promise.reject(i18n.global.t(`tips.tip21`));
      }
    }
    return Promise.resolve();
  }
}
async function validateAccount(rule, value) {
  var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  var rel2 = /^1([3456789])\d{9}$/;
  if (value === "") {
    return Promise.reject(i18n.global.t(`tips.tip7`));
  } else if (!rel1.test(value) && !rel2.test(value)) {
    return Promise.reject(i18n.global.t(`tips.tip18`));
  } else {
    return Promise.resolve();
  }
}

export { validateMobilePhone, validateMobileEmail, validateAccount };
